import React, { useRef, useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import LoadingSpinner from "../../toolkit/LoadingSpinner";
import CommunicationList from "./CommunicationList/CommunicationList";
import CommunicationDetails from "./Communication/CommunicationDetails";
import { PqCommunicationContext } from "../../store/pqCommunication-context";

function CommunicationTab({ onSelectCommunication }) {
  const { globalPqDetails, setGlobalPqDetails } = useContext(
    PqCommunicationContext
  );

  const [pqDetails, setPqDetails] = useState(globalPqDetails);
  const [searchStr, setSearchStr] = useState("");
  const [isListRendered, setIsListRendered] = useState(true);
  const [messageListTitle, setMessageListTitle] = useState("");
  //const [isNavigated, setIsNavigated] = useState(false);

  let interval;
  const handleOnSearchChange = (value) => {
    if (interval) clearTimeout(interval);
    setSearchStr(value.target.value);
    setIsListRendered(false);
    interval = setTimeout(() => setIsListRendered(true), 900);
  };

  const handleItemClick = (prequalificationId, vendorName, clientName) => {
    setPqDetails({ pqId: prequalificationId, vendorName, clientName });
    setGlobalPqDetails({ pqId: prequalificationId, vendorName, clientName });
    setMessageListTitle(vendorName);
    onSelectCommunication(prequalificationId);
  };
  const goToCommunicationList = () => {
    setPqDetails({ pqId: 0, vendorName: "", clientName: "" });
    // setGlobalPqDetails({ pqId: 0, vendorName: "", clientName: "" });
    onSelectCommunication(0);
  };

  return (
    <Box>
      {pqDetails.pqId === 0 && (
        <Box px={3} pt={2}>
          <TextField
            placeholder="Search"
            id="outlined-start-adornment"
            value={searchStr}
            sx={{ m: 1, width: "25ch" }}
            onChange={handleOnSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      )}

      {!isListRendered && <LoadingSpinner />}
      {pqDetails.pqId === 0 && isListRendered && (
        <CommunicationList
          searchStr={searchStr}
          handleItemClick={handleItemClick}
        />
      )}
      <Box className="pt-0 iuop">
        {pqDetails.pqId > 0 && (
          <CommunicationDetails
            pqId={pqDetails.pqId}
            pqDetails={pqDetails}
            setPqId={handleItemClick}
            messageListTitle={messageListTitle}
            goToCommunicationList={goToCommunicationList}
          />
        )}
      </Box>
    </Box>
  );
}
export default CommunicationTab;
